// ─────────────────────────────────────────────────────────────────────────────
// DashFooter, CD's footer (copyright + Terms/Privacy/Support/Status links).
// Static chrome copied verbatim from the mockup.
// ─────────────────────────────────────────────────────────────────────────────

import type { JSX } from 'react';

export function DashFooter(): JSX.Element {
  return (
    <footer className="dash-footer">
      <span className="dash-footer__copy" style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
        © 2026 Artist CNTRL
        {/* cg-product 2026-07-20 (Ryan): every desktop page carries the parent-brand line */}
        <span style={{ opacity: 0.75, display: 'inline-flex', alignItems: 'center', gap: 6 }}>
          · a product of
          <img src="/brand/cg-mark.svg" alt="CNTRL Global" style={{ height: 13, width: 'auto', filter: 'brightness(0)', opacity: 0.5 }} />
          CNTRL Global
        </span>
      </span>
      <nav className="dash-footer__links" aria-label="Footer">
        <a href="/terms.html" target="_blank" rel="noopener">Terms</a>
        <a href="/privacy.html" target="_blank" rel="noopener">Privacy</a>
        <a href="mailto:support@artistcntrl.com">Support</a>
      </nav>
    </footer>
  );
}
